module.exports = __webpack_public_path__ + "img/commandImg4.37f5bc0a.png";